import { render, staticRenderFns } from "./PermList.vue?vue&type=template&id=6f479f35&scoped=true&"
import script from "./PermList.vue?vue&type=script&lang=js&"
export * from "./PermList.vue?vue&type=script&lang=js&"
import style0 from "./PermList.vue?vue&type=style&index=0&id=6f479f35&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f479f35",
  null
  
)

export default component.exports